import {AfterContentInit, Component, Input, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-rc-table-cell',
    template: `<ng-template #tableCell>
    <div class="rc-table-cell" (click)="colClicked($event)" [ngStyle]="{width: col.width}" role="cell">
        <ng-content></ng-content>
    </div>
</ng-template>
`,
    styles: [`.rc-table-cell{display:inline-block}`]
})
export class RcTableCellComponent implements AfterContentInit{
    @Input() col: any = {};

    @ViewChild('tableCell', {read: TemplateRef}) tableCell;

    ngAfterContentInit() {
    }

    colClicked(event) {
        event.rcTableCol = this.col;
    }

}
